import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';

declare var _: any;

@Component({
  selector: 'app-workers-import',
  templateUrl: './workers-import.component.html',
  styleUrls: ['./workers-import.component.scss']
})
export class WorkersImportComponent implements OnInit {

  users : any;
  original_users: any;
  search = "";

  constructor(private router: Router, private route: ActivatedRoute, public okService:OkAloneService, private transloco: TranslocoService) { }


  ngOnInit(): void {

    this.getUsers();

  }
  getUsers(){

    this.okService.get("geotab/users",{})
    .subscribe((data) => {

      this.users = data.body;

      //let self = this;

      //console.log(self.okService.workers);
      // _.forEach(this.users, function(user:any) {
      //   //console.log({"identifier":user.identifier});
      //   let monitor = _.find(self.okService.workers, {"identifier":user.identifier})
      //   if(monitor){
      //     //console.log(monitor);
      //     user.worker_id = monitor.id;
      //   }
      // });

      // compare with current users


      //console.log("users",this.users);

    });

  }

  importWorker(user:any){
    //console.log(user);

    this.okService.post("workers",user)
    .subscribe((data) => {

      //console.log(data);

      user.is_worker = true;

      //this.okService.loadObjects();
      //this.getUsers();

      this.okService.setAlert(this.transloco.translate("The worker ")+user.name+this.transloco.translate(" has been added"),"success");

    });
  }

  doSearch(){
    //console.log(this.search);

    let search = this.search;

    this.okService.get("geotab/users",{search:search})
    .subscribe((data) => {

      //console.log(data);

      this.users = data.body;


    });


  }
  cancelSearch(){
    //console.log(this.search);

    this.search="";

    this.getUsers();

  }
}
